export const SIMPLE_DATE_FORMAT = 'd/M/yyyy'
export const SIMPLE_DATE_FORMAT_2 = 'dd/MM/yyyy'

export const SIMPLE_DATETIME_FORMAT = 'dd/MM/yyyy HH:mm'
